import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  TouchableOpacity,
  Image,
  Linking,
} from 'react-native';
import React, {useEffect, useState} from 'react';
import {connect, useSelector} from 'react-redux';
import {back_arrow, right_arrow, smile_coin} from '../../utils/images';
import {Color, globalFontStyle, globalStyle} from '../../assets';
import Colors from '../../assets/Color/Colors';
import {SafeAreaView} from 'react-native-safe-area-context';
import FastImage from '../../common/FastImage';
import FormTextLabel from '../../commonComponents/FormTextLabel';
import {getRewardsDetails} from './redux/rewards.action';
import Width from '../../assets/Width';
import CommonModal from '../../commonComponents/commonModal';
import {isMobile} from '../../utils/commonMethods';
import {globalConst} from '../../utils/globalConstant';
import {TEST_API} from '../../utils/apiUrl';
import {INDIA} from '../../utils/constants';
import {getUser} from '../Profile/redux/profile.action';
import {TabActions, useFocusEffect} from '@react-navigation/native';
import {deepLinkConst} from '../../common/dynamicLinkConst';
import {Button} from '../../components/core/Button';
import { Icon } from '@iconify/react';
import { globalConfigurableData } from '../../utils/globalConstant';

const Rewards = ({
  navigation,
  getRewardsDetails,
  rewardsDetailsData,
  getUser,
}) => {
  const [isShowConfirmBottomSheet, setShowBottomSheet] = useState(null);

  let userInfo = useSelector(({profile}) => profile?.profileData);
  let region = userInfo?.region_code ?? 'INDIA';

  useFocusEffect(
    React.useCallback(() => {
      getRewardsDetails();
      getUser();
    }, []),
  );

  const onPress = data => {
    if (!data.disabled) {
      if (data?.isBottomSheet) {
        setShowBottomSheet(data);
      } else if (data?.href?.includes('usdt')) {
        const configRewards = {
          limit: rewardsDetailsData?.limits?.redeemCrypto,
          exchangeRate: rewardsDetailsData?.exchange_rate?.USDT,
          isUSDT: true,
          guidline: data?.disclaimers,
          exchange_string: data?.exchange_string,
        };

        navigation.navigate('RewardsStack', {
          screen: 'RedeemRewards',
          params: {limitData: configRewards},
        });
      } else {
        navigation.push('Refer');
      }
    }
  };

  const routeRedirection = () => {
    setShowBottomSheet(null);
    if (isShowConfirmBottomSheet?.href?.includes('WalletStack')) {
      if (!userInfo?.isProfileComplete) {
        navigation.navigate('Profile');
        return;
      }
      navigation.push('WalletStack', {
        screen: 'WalletAdd',
      });
    } else if (isShowConfirmBottomSheet?.href?.includes('usdt')) {
      const configRewards = {
        limit: rewardsDetailsData?.limits?.redeemCrypto,
        exchangeRate: rewardsDetailsData?.exchange_rate?.USDT,
        isUSDT: true,
        guidline: isShowConfirmBottomSheet?.disclaimers,
        exchange_string: isShowConfirmBottomSheet?.exchange_string,
      };

      navigation.navigate('RewardsStack', {
        screen: 'RedeemRewards',
        params: {limitData: configRewards},
      });
    } else if (isShowConfirmBottomSheet?.href?.includes('depositcredit')) {
      const configRewards = {
        limit: rewardsDetailsData?.limits?.tradex,
        exchangeRate: rewardsDetailsData?.exchange_rate?.tradex,
        isUSDT: false,
        guidline: isShowConfirmBottomSheet?.disclaimers,
        exchange_string: isShowConfirmBottomSheet?.exchange_string,
      };
      navigation.navigate('RewardsStack', {
        screen: 'RedeemRewards',
        params: {limitData: configRewards},
      });
    } else if (
      isShowConfirmBottomSheet?.hrefRedirection?.includes('external')
    ) {
      Linking.openURL(isShowConfirmBottomSheet?.href);
    } else if (
      isShowConfirmBottomSheet?.hrefRedirection?.includes('internal')
    ) {
      if (isShowConfirmBottomSheet?.href?.includes('event')) {
        const spliArr = isShowConfirmBottomSheet?.href.split('=');
        const internalEvent = {id: spliArr[1]};
        navigation.push('Event', {
          eventId: internalEvent?.id,
          isMulti: false,
        });
      } else if (isShowConfirmBottomSheet?.href?.includes('contestEvents')) {
        const spliArr = isShowConfirmBottomSheet?.href?.split('=');
        let internalEvent = false;
        if (spliArr?.length > 1) {
          internalEvent = spliArr[1];
        }
        const jumpToAction = TabActions.jumpTo(deepLinkConst['Contest'], {
          isContest: internalEvent,
        });
        navigation.navigate('Home');
        navigation.dispatch(jumpToAction);
      } else if (isShowConfirmBottomSheet?.href?.includes('wallet/funds')) {
        const pageObj = deepLinkConst[isShowConfirmBottomSheet?.href];
        if (pageObj.child) {
          navigation.navigate(pageObj.parent, {screen: pageObj.child});
        } else {
          navigation.navigate(pageObj.parent);
        }
      }
    }
  };

  return (
    <SafeAreaView style={[globalStyle.pageContainer, {flexGrow: 1}]}>
      <CommonModal
        onModalCallBack={() => {
          setShowBottomSheet(null);
        }}
        customModalStyle={[globalStyle.modalView]}
        showModal={isShowConfirmBottomSheet ? true : false}>
        <View>
          <View style={styles.bottomSheetHeader}>
            <Image
              style={{width: 30, height: 30}}
              source={{
                uri: TEST_API + isShowConfirmBottomSheet?.icon,
              }}
            />
            <View
              style={{
                marginHorizontal: 15,
                flex: 1,
                justifyContent: 'space-between',
                flexDirection: 'row',
                alignItems: 'center',
              }}>
              <Text
                style={{
                  ...globalFontStyle.appFontHeading,
                  color: Colors.tradexBlue,
                }}>
                {isShowConfirmBottomSheet?.label}
              </Text>
            </View>
          </View>
          <View style={{paddingVertical: 35, paddingHorizontal: 30}}>
            <Text
              style={{
                ...globalFontStyle.appFontBody,
                color: Colors.black,
                textAlign: 'center',
              }}>
              {isShowConfirmBottomSheet?.description}
            </Text>
          </View>
          <Button
            variant="primary"
            onPress={() => {
              setTimeout(() => {
                routeRedirection();
              }, globalConst?.buttonTimer);
            }}
            style={[
              styles.btnExternalStyle,
              {marginBottom: 16, marginHorizontal: 16},
            ]}
            translate={true}
          >
            {isShowConfirmBottomSheet?.actionText}
          </Button>
        </View>
      </CommonModal>
      <ScrollView
        style={{
          paddingBottom: 22,
          flexGrow: 1,
          backgroundColor: Colors.bgWhite,
        }}
        showsVerticalScrollIndicator={false}
        contentContainerStyle={{flexGrow: 1}}>
        <View style={styles.top_box}>
          <TouchableOpacity
            style={{marginTop: 15, marginBottom: 20}}
            onPress={() => {
              if (!navigation.canGoBack()) {
                navigation.navigate('Home');
              } else {
                navigation.pop(1);
              }
            }}>
            <Icon 
              icon="tabler:arrow-left"
              style={{ width: 24, height: 24 }}
              color={globalConfigurableData.primaryTextColor1}
            />
          </TouchableOpacity>
          <View style={styles.rewardsBox}>
            <View
              style={{
                backgroundColor: Colors.tradexBlue1,
                borderRadius: 8,
                padding: 6,
              }}>
              <FastImage
                style={{width: 28, height: 28}}
                source={smile_coin()}
              />
            </View>

            <View
              style={{marginHorizontal: 20, flex: 1, justifyContent: 'center'}}>
              <Text
                style={{...globalFontStyle.appFontTitle, color: Colors.black}}>
                {userInfo?.coinsp?.toFixed(2)}
              </Text>
            </View>
            {/* <View style={{justifyContent: 'center'}}>
              <FormTextLabel
                labelStyles={{
                  ...globalFontStyle.appFontSmallText,
                  color: Colors.lightgrey,
                }}
                label={'1 Token = '}>
                <Text
                  style={{
                    ...globalFontStyle.appFontSmallTextBold,
                    color: Colors.black,
                  }}>
                  ${rewardsDetailsData?.exchange_rate?.USDT}
                </Text>
              </FormTextLabel>
            </View> */}
          </View>
        </View>
        <View style={{paddingHorizontal: 18, marginTop: 25}}>
          <FormTextLabel
            labelStyles={{
              ...globalFontStyle.appFontTitle,
              color: Colors.black,
              marginBottom: 20,
            }}
            label={'Do more with your Tokens'}
          />
          {rewardsDetailsData?.actions?.map((item, i) => {
            return (
              <TouchableOpacity
                onPress={() => {
                  onPress(item);
                }}
                style={[
                  item.disabled ? {opacity: 0.4} : null,
                  styles.rewardsOptionBox,
                ]}
                key={i}>
                {item?.disabled && (
                  <FormTextLabel
                    label={'Under Maintenance'}
                    labelStyles={{
                      ...globalFontStyle.appFontSubTextBold,
                      position: 'absolute',
                      paddingHorizontal: 12,
                      paddingVertical: 3,
                      backgroundColor: '#FFD54B',
                      color: Colors.black,
                      borderRadius: 5,
                      opacity: 1,
                      zIndex: 100,
                      right: 0,
                    }}
                  />
                )}
                <View
                  style={{
                    paddingVertical: 12,
                    paddingHorizontal: 12,
                    borderRightColor: Colors.borderColor,
                    borderRightWidth: 0.75,
                  }}>
                  <Image
                    style={{width: 32, height: 32}}
                    source={{
                      uri: TEST_API + item?.icon,
                    }}
                  />
                </View>
                <View
                  style={{
                    marginHorizontal: 12,
                    flex: 1,
                    justifyContent: 'space-between',
                    flexDirection: 'row',
                    alignItems: 'center',
                  }}>
                  <Text
                    style={{
                      ...globalFontStyle.appFontBody,
                      color: Colors.black,
                    }}>
                    {item?.label}
                  </Text>
                  <FastImage
                    style={{width: 45, height: 45, marginRight: 8}}
                    source={right_arrow()}
                  />
                </View>
              </TouchableOpacity>
            );
          })}
        </View>
      </ScrollView>
    </SafeAreaView>
  );
};

const mapStateToProps = ({rewardsReducer}) => ({
  rewardsDetailsData: rewardsReducer.rewardsDetailsData,
});
const mapDispatchToProps = {
  getRewardsDetails,
  getUser,
};

export default connect(mapStateToProps, mapDispatchToProps)(Rewards);

const styles = StyleSheet.create({
  top_box: {
    alignContent: 'center',
    backgroundColor: Colors.tradexBlue,
    paddingTop: 25,
    paddingHorizontal: 16,
  },
  rewardsBox: {
    marginBottom: 20,
    alignSelf: 'flex-start',
    justifyContent: 'space-between',
    width: Width.width - 32,
    flexDirection: 'row',
    backgroundColor: Colors.bgWhite,
    paddingHorizontal: 12,
    paddingVertical: 12,
    borderRadius: 8,
  },
  rewardsOptionBox: {
    marginBottom: 15,
    alignSelf: 'flex-start',
    justifyContent: 'space-between',
    width: Width.width - 32,
    flexDirection: 'row',
    borderColor: Colors.borderColor,
    borderRadius: 12,
    borderWidth: 0.75,
  },
  bottomSheetHeader: {
    marginTop: -15,
    marginHorizontal: 0,
    alignSelf: 'flex-start',
    flexDirection: 'row',
    padding: 16,
    width: Width.width,
    backgroundColor: Colors.tradexBlue1,
  },
});
